import classNames from 'classnames'
import { useRef } from 'react'
import { useMobileCards } from './useMobileCards'

type Props = React.DetailedHTMLProps<React.TableHTMLAttributes<HTMLTableElement>, HTMLTableElement> & {
  wrapperClassName?: string
}

// Tabella semplice che su mobile mostra le righe come card (come StickyTable, ma senza altezza fissa)
export default function CardTable({ wrapperClassName, onClick, ...props }: Props) {
  const tableRef = useRef<HTMLTableElement>(null)
  const handleCardClick = useMobileCards(tableRef)

  return (
    <div className={classNames('mobile-cards', wrapperClassName)}>
      <table
        ref={tableRef}
        onClick={(e) => {
          handleCardClick(e)
          onClick?.(e)
        }}
        {...props}
      />
    </div>
  )
}
